import { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  Typography,
  Box,
  Divider
} from '@material-ui/core'
import ReportProblemIcon from '@material-ui/icons/ReportProblem'
import PaymentIcon from '@material-ui/icons/Payment'
import { useSelector, useDispatch } from 'react-redux'
import { obtenerAtrasosClienteByIdPaquete } from '../../../ducks/clientesDuck'
import { FormatoFechaIso } from '../../../utils/FormatFecha'
import { Alert } from '@material-ui/lab'


const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    borderLeft: '3px solid #ccc',
  },
  event: {
    position: 'relative',
    marginBottom: theme.spacing(4),
    paddingLeft: theme.spacing(4),
  },
  dot: {
    width: 18,
    height: 18,
    borderRadius: '50%',
    position: 'absolute',
    left: -9,
    top: 4,
    zIndex: 1,
  },
  icon: {
    fontSize: '1.5rem',
    verticalAlign: 'middle',
    marginRight: theme.spacing(1),
  },
  atraso: {
    color: '#c62828',
    backgroundColor: '#ffebee',
    borderColor: '#e53935',
  },
  regularizado: {
    color: '#2e7d32',
    backgroundColor: '#e8f5e9',
    borderColor: '#2e7d32',
  },
  fecha: {
    fontWeight: 600,
    fontSize: '1rem',
  },
  descripcion: {
    fontSize: '0.95rem',
    marginTop: theme.spacing(0.5),
  },
}))

// const mockEventos = [
//   { tipo: 'atraso', fecha: '2024-02-15', numPago: 3 },
//   { tipo: 'regularizado', fecha: '2024-03-01', numPago: 3 },
//   { tipo: 'atraso', fecha: '2024-04-10', numPago: 5 },
//   { tipo: 'regularizado', fecha: '2024-05-01', numPago: 5 },
//   { tipo: 'atraso', fecha: '2024-07-05', numPago: 8 },
// ]

export default function HistorialAtrasosTimeline() {
  const { referencia, cliente, listaAtrasos } = useSelector(store => store.cliente)
  //204970
  const classes = useStyles()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(obtenerAtrasosClienteByIdPaquete({ idPaquete: cliente.paquete.Id_Paquete }))
  }, [dispatch, cliente.paquete.Id_Paquete])

  if (listaAtrasos.length === 0)
    return <Alert severity="info">No hay movimientos para mostrar</Alert>


  return (
    <Box>
      <Box className={classes.root}>
        {listaAtrasos.map((item, idx) => {
          const isAtraso = true
          const tipoClase = isAtraso ? classes.atraso : classes.regularizado
          const Icon = isAtraso ? ReportProblemIcon : PaymentIcon
          const descripcion = isAtraso
            ? `Atraso en pago #${item.numPago}`
            : `Pago #${item.numPago} regularizado`

          return (
            <Box key={idx} className={classes.event}>
              <span className={`${classes.dot} ${tipoClase}`} />
              <Typography className={`${classes.fecha} ${tipoClase}`}>
                <Icon className={classes.icon} />
                {FormatoFechaIso({ date: item.FechaRegistro, formato: "dd/MMM/yyyy" })}
              </Typography>
              <Typography className={classes.descripcion}>{item.Descripcion}</Typography>
              {idx < listaAtrasos.length - 1 && <Divider style={{ marginTop: 16 }} />}
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
